import { createContext } from 'react';

import { RequestState } from '../../../../api/constants/RequestState';
import { AuthTokensRefreshData } from './types';

export const AuthTokensRefreshDataContext =
  createContext<AuthTokensRefreshData>({
    isTokenValid: false,
    tokenRefreshState: RequestState.Idle,
  });
